import { useEffect, useState } from 'react'
import { subscribePending, subscribeDraining } from '@/lib/offline'

export default function OnlineStatus() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true)
  const [pending, setPending] = useState(0)
  const [draining, setDraining] = useState(false)

  useEffect(() => {
    const onUp = () => setOnline(true)
    const onDown = () => setOnline(false)
    window.addEventListener('online', onUp)
    window.addEventListener('offline', onDown)
    const unsubP = subscribePending(setPending)
    const unsubD = subscribeDraining(setDraining)
    return () => {
      window.removeEventListener('online', onUp)
      window.removeEventListener('offline', onDown)
      unsubP(); unsubD()
    }
  }, [])

  if (online && pending === 0) return null

  const cls = !online ? 'badge badge-warn' : 'badge badge-neutral'
  const text = !online
    ? (pending > 0 ? `Offline · ${pending} waiting` : 'Offline')
    : draining ? `Syncing ${pending}…` : `${pending} waiting`

  return <span className={cls} style={{ marginRight: 'var(--space-2)' }}>{text}</span>
}
